import type { ResumeData } from "@/types/resume";

export function formatDate(dateStr: string): string {
  if (!dateStr) return "";
  const [year, month] = dateStr.split("-");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[parseInt(month) - 1] || ""} ${year}`;
}

export function getOrderedSections(data: ResumeData): string[] {
  const defaultOrder = [
    "summary", "workExperience", "education", "skills",
    "projects", "certifications", "languages", "achievements",
  ];
  const order = data.sectionOrder?.filter((s) => s !== "personalInfo") || defaultOrder;
  return order.length > 0 ? order : defaultOrder;
}
